var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLight = function SvgLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33 7.63H0V6.37h3.32a4.07 4.07 0 0 0-.06.6 3.6 3.6 0 0 0 .07.66Zm1.49-3.69L2.49 1.61l-.88.88 2.33 2.34a3.55 3.55 0 0 1 .88-.89Zm5.25.87 2.32-2.32-.88-.88-2.32 2.32a3.68 3.68 0 0 1 .88.88ZM7 3.22a4.2 4.2 0 0 1 .62.06V0H6.37v3.29A3.39 3.39 0 0 1 7 3.22Zm3.7 3.15a4.07 4.07 0 0 1 .06.6 4.76 4.76 0 0 1-.06.66H14V6.37ZM9.16 10l2.35 2.35.88-.88-2.34-2.31a3.91 3.91 0 0 1-.89.84ZM7 10.72a4.48 4.48 0 0 1-.64-.06V14h1.27v-3.34a4.2 4.2 0 0 1-.63.06ZM4 9.15l-2.39 2.36.88.88L4.85 10A3.68 3.68 0 0 1 4 9.15Zm3-4.68A2.5 2.5 0 1 0 9.51 7 2.5 2.5 0 0 0 7 4.47Z"
  })));
};

export default SvgLight;